module.exports = __webpack_public_path__ + "img/office-2017-fangzhiguan.3d837d6c.jpg";